var map = {
	"./1.jpg": "93b2",
	"./2.jpg": "6e86",
	"./3.jpg": "9bea",
	"./4.jpg": "f580",
	"./5.jpg": "86cd",
	"./6.jpg": "3b39",
	"./7.jpg": "5e44"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb02";